import React,{useState,useEffect} from 'react'
import { getNewToday, getOverDue, getPendingThisWeek, getPendingToday,getPendingTomorrow, getTotal } from '../pendingReportServices';
import { Dialog, DialogContent } from '@mui/material';
import { Link } from 'react-router-dom';
import moment from 'moment';
import GrievanceListDialog from './GrievanceListDialog';

function GroupPendencyTotal({supervisorList,getMasterLabel}) {
    const [reportData,setReportData] = useState(null);
    const [dialogStatus, setDialogStatus] = useState(false);
    const [pendingData,setPendingData] = useState(null);

    const prepareTotalReport = () =>{
        let _reportData = [];
        if(supervisorList){
            supervisorList.forEach(supervisor => {
                _reportData = [..._reportData,...supervisor.grievanceList];
            });
        }
        setReportData(_reportData);
    }

    useEffect(()=>{
        prepareTotalReport();
    },[supervisorList])

    const handleCountClick = ( func, type) =>{
        let data = func(reportData,type);
        setPendingData(data);
        setDialogStatus(true);
    }

    return (
        <div className='card p-3 mb-3 shadow'>
            {reportData &&
                <div className='row'>
                    <div className="col-md-2 ">
                        <div className="card bg-success text-white shadow p-1">
                            <p>New Today</p>
                            <span className="text-center">
                                <h1 type="button" onClick={()=>handleCountClick(getNewToday)}>
                                    {getNewToday(reportData).length}
                                </h1>
                            </span>
                        </div>
                    </div>

                    <div className="col-md-2 ">
                        <div className="card bg-warning shadow p-1">
                            <p>Pending Today</p>
                            <span className="text-center">
                                <h1 type="button" onClick={()=>handleCountClick(getPendingToday)}>
                                    {getPendingToday(reportData).length}
                                </h1>
                            </span>
                        </div>
                    </div>

                    <div className="col-md-2 ">
                        <div className="card bg-info shadow p-1">
                            <p>Pending Tomorrow</p>
                            <span className="text-center">
                                <h1 type="button" onClick={()=>handleCountClick(getPendingTomorrow)}>
                                    {getPendingTomorrow(reportData).length}
                                </h1>
                            </span>
                        </div>
                    </div>

                    <div className="col-md-2 ">
                        <div className="card bg-primary text-white shadow p-1">
                            <p>Pending This Week</p>
                            <span className="text-center">
                                <h1 type="button" onClick={()=>handleCountClick(getPendingThisWeek)}>
                                    {getPendingThisWeek(reportData).length}
                                </h1>
                            </span>
                        </div>
                    </div>

                    <div className="col-md-2 ">
                        <div className="card bg-danger text-white shadow p-1">
                            <p>Over Due</p>
                            <span className="text-center">
                                <h1 type="button" onClick={()=>handleCountClick(getOverDue)}>
                                    {getOverDue(reportData).length}
                                </h1>
                            </span>
                        </div>
                    </div>
                    <div className="col-md-2 ">
                        <div className="card bg-dark text-white shadow p-1">
                            <p>Total</p>
                            <span className="text-center">
                                <h1 type="button" onClick={()=>handleCountClick(getTotal)}>
                                    {getTotal(reportData).length}
                                </h1>
                            </span>
                        </div>
                    </div>
                </div>
            }
            <GrievanceListDialog grievanceList={pendingData} dialogStatus={dialogStatus} setDialogStatus={setDialogStatus} getMasterLabel={getMasterLabel} />
        </div>
    )
}

export default GroupPendencyTotal